<template>
  <div>
    <button class="btn btn-info" @click="selectFile" v-if="!uploadEnd && !uploading">
      {{caption}}
    </button>
    <form ref="form">
      <input
      :id="inputId"
      type="file"
      :name="inputId"
      ref="uploadInput"
      accept="*"
      :multiple="false"
      @change="detectFiles($event)" />
    </form>
      <!-- <v-progress-circular
        v-if="uploading && !uploadEnd"
        :size="100"
        :width="15"
        :rotate="360"
        :value="progressUpload"
        color="primary">
        {{ progressUpload }}%
      </v-progress-circular> -->
      <div class="spinner-border text-primary" role="status" v-if="uploading && !uploadEnd">
        Uploading...
      </div>
      <!-- <img v-if="uploadEnd" :src="downloadURL" width="400" /> -->
      <div v-if="uploadEnd">
        <button class="btn btn-sm btn-dark" @click="deleteImage()">เปลี่ยนไฟล์</button>
      </div>
  </div>
</template>

<script>
import { firestorage } from '@/firebase/firestorage'
export default {
  props: {
    oldImgUrl: {
      type: String,
      required: false
    },
    caption: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    progressUpload: 0,
    fileName: '',
    uploadTask: '',
    uploading: false,
    uploadEnd: false,
    downloadURL: ''
  }),
  created () {
    // if (this.oldImgUrl) this.setCoverImgOnUpdate()
  },
  methods: {
    selectFile () {
      this.$refs.uploadInput.click()
    },
    detectFiles (e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x])
      })
    },
    upload (file) {
      this.fileName = file.name
      this.uploading = true
      this.uploadTask = firestorage.ref('zr12/' + file.name).put(file)
    },
    deleteImage () {
      if (this.oldImgUrl === '') {
        this.deleteImgOnFirebase()
      } else {
        this.deleteImgOnUpdate()
      }
      this.$refs.form.reset()
    },
    setCoverImgOnUpdate () {
      this.uploadEnd = true
      this.downloadURL = this.oldImgUrl
    },
    deleteImgOnFirebase () {
      firestorage
        .ref('zr12/' + this.fileName)
        .delete()
        .then(() => {
          this.uploading = false
          this.uploadEnd = false
          this.downloadURL = ''
          this.$emit('downloadURL', this.downloadURL)
        })
        .catch((error) => {
          console.error(`file delete error occured: ${error}`)
        })
    },
    deleteImgOnUpdate () {
      this.uploading = false
      this.uploadEnd = false
      this.downloadURL = ''
      this.$emit('downloadURL', this.downloadURL)
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.uploadEnd = true
          this.downloadURL = downloadURL
          this.$emit('downloadURL', downloadURL)
        })
      })
    }
  }
}
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0,0,0,0);
}
</style>



// WEBPACK FOOTER //
// src/components/FileUploader.vue